import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { camp } from "@/data/camp";
import RegisterLink from "@/components/RegisterLink";

const navItems = [
  ["The Camp", "the-camp"],
  ["Schedule", "schedule"],
  ["Coaches", "coaches"],
  ["About Us", "about"],
  ["FAQ", "faq"],
];

function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const close = () => setMenuOpen(false);
    window.addEventListener("hashchange", close);
    return () => window.removeEventListener("hashchange", close);
  }, []);

  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-inner page-width">
        <a className="brand-lockup" href="#home" onClick={() => setMenuOpen(false)} data-testid="brand-logo-slot" aria-label="Top Tier Sports Camps home">
          <span className="brand-mark">TT</span>
          <span className="brand-copy"><strong>TOP TIER</strong><small>SPORTS CAMPS</small></span>
        </a>
        <nav className="desktop-nav" aria-label="Main navigation">
          {navItems.map(([label, href]) => <a key={href} href={`#${href}`} data-testid={`nav-${href}-link`}>{label}</a>)}
        </nav>
        <div className="header-actions">
          <span className="header-date">{camp.dateShort}</span>
          <RegisterLink className="header-register" testId="header-register-btn" />
          <button className="menu-toggle" type="button" onClick={() => setMenuOpen((open) => !open)} aria-label={menuOpen ? "Close menu" : "Open menu"} aria-expanded={menuOpen} aria-controls="mobile-menu" data-testid="mobile-menu-toggle">
            {menuOpen ? <X size={22} strokeWidth={1.8} /> : <Menu size={22} strokeWidth={1.8} />}
          </button>
        </div>
      </div>
      {menuOpen && <div className="mobile-menu" id="mobile-menu" data-testid="mobile-menu-panel">
        <nav aria-label="Mobile navigation">
          {navItems.map(([label, href]) => <a key={href} href={`#${href}`} onClick={() => setMenuOpen(false)} data-testid={`mobile-nav-${href}-link`}>{label}</a>)}
        </nav>
        <RegisterLink className="mobile-register" testId="mobile-register-btn" />
      </div>}
    </header>
  );
}

export default SiteHeader;
